import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { autobind } from 'core-decorators';
import { createFilter, components } from 'react-select';
import AsyncSelect from 'react-select/async';
import classNames from 'classnames';

import httpSelector from 'src/services/httpSelector';
import { FormGroup, FormFeedback, Label } from 'reactstrap';
import ItemMulti from '../item-multi-lookup';
import ContentManager from '../content-manager';
import guid from 'src/utils/guid';
import CopyToClipboard from '../CopyToClipboard';
import Info from '../info';
import LucideIcon from '../lucide-icon';
import CompactMultiValueContainer, {
  compactMultiStyles,
} from '../compact-multi-value';
import { getTopOverlayZIndex } from 'src/utils/zIndexOverlay';

import '../../styles/react-select.scss';
import css from 'src/utils/css';
import './style.scss';

let classes = css`
  .select {
    position: relative;
    display: block;
    width: 100%;
    min-width: 0;
    max-width: 100%;

    .Select-control {
      border: 1px solid #dde6e9;
      table-layout: fixed;

      .Select-multi-value-wrapper {
        width: 100%;
        .Select-input {
          max-width: 80%;
          overflow: hidden;
          /*height: 31px;*/
        }
      }

      .Select-arrow-zone {
      }
    }

    .Select-menu-outer {
      z-index: 1050 !important;
    }

    .input-group-btn {
      height: 100%;
      position: relative;
      font-size: 0;
      white-space: nowrap;
      vertical-align: middle;
      width: 1%;
      display: table-cell;

      > .ant-btn:first-child:not(:last-child) {
        border-radius: 0;
      }

      > .ant-btn:last-child {
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
      }
    }
  }
`;

@autobind
class SelectAsync extends React.Component {
  static defaultProps = {
    showModal: true,
    showLabel: true,
    showNew: true,
  };

  constructor(props) {
    super(props);
    this.chaveId = guid();

    this.state = {
      searchComponentId: `LOOKUP-ID-${guid()}`,
      isAlreadySearching: false,
    };
  }

  async componentDidMount() {
    if (this.props.parametroUrl) {
      this.props.model.value = this.props.parametroUrl;
    }
    if (this.props.model && this.props.model.value) {
      if (this.props.multi) {
        this.getOptionsMultiFromProps();
      } else {
        const labelKey = this.props.model.value[this.props.labelKey];
        const valueKey = this.props.model.value[this.props.valueKey];
        if (!labelKey && valueKey) {
          // busca a descricao do lookup caso seja passado somente o ID
          var response = await httpSelector
            .getHttp(this.props.viewType)
            .post(`${this.props.url}/Search`, {
              id: valueKey,
            });
          const optionValue = this.getOptionValue(this.props.model.value);
          var returnValue =
            response.data.list.find(
              (v) => this.getOptionValue(v) == optionValue
            ) || response.data.list.find((v) => v.id == valueKey);
          if (returnValue)
            this.props.model.requestChange &&
              this.props.model.requestChange(returnValue);
        }
      }
    }

    if (!this.props.blockingOnFirstClick) this.handleAddObserver();
  }

  componentWillUnmount = () => {
    this.handleRemoveObserver();
  };

  handleAddObserver() {
    const root = document.getElementById('root');

    this.observer = new MutationObserver(() => {
      const element = document.getElementById(this.state.searchComponentId);
      this.setState({
        isAlreadySearching: element != null,
      });
    });

    this.observer.observe(root, { subtree: true, childList: true });
  }

  handleRemoveObserver = () => {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
  };

  async getOptionsMultiFromProps() {
    var newValue = [];
    await this.props.model?.value?.forEach(async (item, index, array) => {
      const labelKey = item[this.props.labelKey];
      const valueKey = item[this.props.valueKey];
      if (!labelKey && valueKey) {
        const response = await httpSelector
          .getHttp(this.props.viewType)
          .post(`${this.props.url}/Search`, {
            id: valueKey,
          });
        const optionValue = this.getOptionValue(item);
        const returnValue =
          response.data.list.find(
            (v) => this.getOptionValue(v) == optionValue
          ) || response.data.list.find((v) => v.id == valueKey);

        newValue.push(returnValue);
      }

      if (newValue.length > 0 && index === array.length - 1)
        this.props.model.requestChange &&
          this.props.model.requestChange(newValue);
    });
  }

  handleChange(value) {
    this.props.model.requestChange && this.props.model.requestChange(value);
  }

  getOptionValue(option) {
    return this.props.getOptionValue
      ? this.props.getOptionValue(option)
      : option?.[this.props.valueKey];
  }

  getDescricaoMulti(list) {
    return list.map((item) => item[this.props.labelKey]).join('; ');
  }

  renderMulti(item) {
    if (this.props.valueComponent) return this.props.valueComponent(item);
    else {
      return (
        <ItemMulti
          label={item.value[this.props.labelKey]}
          onRemove={item.onRemove.bind(this, item.value)}
          multi={this.props.multi}
          disabled={this.props.disabled}
        ></ItemMulti>
      );
    }
  }

  CustomMultiValue = (props) => {
    const { labelKey } = this.props;

    if (this.props.valueComponent) {
      return this.props.valueComponent({
        value: props.data,
        onRemove: props.removeProps?.onClick,
      });
    }

    return (
      <ItemMulti
        label={props.data[labelKey]}
        onRemove={props.removeProps?.onClick}
        disabled={props.isDisabled || this.props.disabled}
      />
    );
  };

  CustomSingleValue = (props) => {
    if (this.props.valueComponent) {
      return (
        <components.SingleValue {...props}>
          {this.props.valueComponent({
            value: props.data,
            onRemove: null,
          })}
        </components.SingleValue>
      );
    }
    return (
      <components.SingleValue {...props}>
        {props.children}
      </components.SingleValue>
    );
  };

  CustomIndicator = (props) => {
    const { showSearch, disabled, useClickToOpen } = this.props;
    if (!showSearch || disabled)
      return <components.DropdownIndicator {...props} />;

    const stopAndOpen = (e) => {
      if (e) {
        e.preventDefault();
        e.stopPropagation();
      }
      this.handleSearch();
    };

    const stopOnly = (e) => {
      if (e) {
        e.preventDefault();
        e.stopPropagation();
      }
    };

    return (
      <div
        style={{
          padding: '8px',
          display: 'flex',
          alignItems: 'center',
          cursor: 'pointer',
        }}
        onMouseDown={useClickToOpen === false ? stopAndOpen : stopOnly}
        onClick={useClickToOpen === false ? stopOnly : stopAndOpen}
      >
        <LucideIcon size={16} color="#1d7789" icon="Search" />
      </div>
    );
  };

  // Calcula o z-index do Dialog de busca para garantir que ele abra acima
  getSearchDialogZIndex() {
    if (this.props.searchDialogZIndex) return this.props.searchDialogZIndex;

    const maxZIndex = getTopOverlayZIndex();
    return maxZIndex > 11000 ? maxZIndex + 1 : undefined;
  }

  handleSearch() {
    if (this.state.isAlreadySearching) return;

    if (this.props.blockingOnFirstClick) {
      this.setState({
        isAlreadySearching: true,
      });
    }

    let selectedIds = null;
    let selectedItems = [];
    if (this.props.model && this.props.model.value) {
      if (this.props.model.value && this.props.model.value.length > 0) {
        selectedItems = this.props.model.value.map((d) => d);
        selectedIds = this.props.model.value;
      } else {
        selectedIds = [].concat(this.props.model.value);
        selectedItems = [...selectedIds];
      }
    }

    ContentManager.addContent(
      <this.props.searchComponent
        id={this.state.searchComponentId}
        className="popupOpen"
        zIndex={this.getSearchDialogZIndex()}
        parameters={{ ...this.props.data }}
        multiple={this.props.multi}
        showModal={this.props.showModal}
        dialogWidth="80%"
        hierarchy={this.props.hierarchy}
        select={true}
        selectedCallback={this.handleCustomSelectSearch}
        selectedIds={selectedIds}
        selectedItems={selectedItems}
        kanban={false}
        showNew={this.props.showNew}
        selecionarAvaliador={this.props.selecionarAvaliador}
        ehFluxoNegociacaoMetas={this.props.ehFluxoNegociacaoMetas}
        showSearch={this.props.showSearch}
        parametersSearchComponent={this.props.parametersSearchComponent}
        checkSelected={this.props.checkSelected}
        showConfirmButton={this.props.showConfirmButton}
        getItemKey={this.props.getItemKey || this.props.getOptionValue}
      />
    );
  }

  handleCustomSelectSearch(itens) {
    if (this.props.multi) {
      this.props.model.requestChange(itens ? [...itens] : []);
    } else if (itens.length > 0) {
      let item = {
        ...itens[0],
      };
      this.setState({ defaultValue: item });
      this.props.model.requestChange(item);
    }
  }

  async refresh(input) {
    const { loadOnStart } = this.props;
    if (!input && !loadOnStart) {
      return [];
    }
    try {
      const response = await httpSelector
        .getHttp(this.props.viewType)
        .post(`${this.props.url}/Search`, {
          ...this.props.data,
          text: input,
        });
      return response?.data?.list || [];
    } catch (err) {
      console.error(err);
      return [];
    }
  }

  getOptions(input) {
    clearTimeout(this.textoPesquisaDebounceId);

    return new Promise((resolve) => {
      this.textoPesquisaDebounceId = setTimeout(() => {
        this.refresh(input).then((options) => {
          resolve(options);
        });
      }, 500);
    });
  }

  renderArrow() {
    const stopAndOpen = (e) => {
      if (e) {
        e.preventDefault();
        e.stopPropagation();
      }
      this.handleSearch();
    };

    const stopOnly = (e) => {
      if (e) {
        e.preventDefault();
        e.stopPropagation();
      }
    };

    return (
      <div
        style={{
          height: '100%',
          width: '100%',
          display: 'flex',
          alignItems: 'center',
        }}
        onMouseDown={
          this.props.useClickToOpen === false ? stopAndOpen : stopOnly
        }
        onClick={this.props.useClickToOpen === false ? stopOnly : stopAndOpen}
        // usar a propriedade "this.props.useClickToOpen === false" evita bug que abre o modal 2 vezes ao clicar no lookup.
      >
        <LucideIcon
          style={{ position: 'absolute' }}
          size={16}
          color="#1d7789"
          icon="Search"
        >
          +
        </LucideIcon>
      </div>
    );
  }

  render() {
    let {
      model,
      multi,
      valueKey,
      getOptionValue,
      getItemKey,
      labelKey,
      labelValue,
      optionRenderer,
      valueRenderer,
      clearable,
      disabled,
      placeholder,
      required,
      formGroupStyle,
      intl,
      showLabel,
      customClassname = '',
      controlStyle = {},
      compactMulti,
      showHint = false,
      labelHint,
      idHint,
      hintPosition = 'bottom',
      'data-testid': dataTestId,
      ...other
    } = this.props;
    const isCompactMulti = compactMulti && multi;

    return (
      <FormGroup
        validationstate={model.errors ? 'error' : null}
        style={formGroupStyle}
        noMargin={formGroupStyle?.marginBottom == 0}
      >
        {showLabel && model.label && (
          <Label className="control-label d-flex align-items-center">
            <CopyToClipboard
              text={labelValue || model.label}
              value={model.value}
              required={required}
            />
            {showHint && labelHint && (
              <Info
                id={idHint || `lookup-hint-${this.chaveId}`}
                className="pl-1 pb-1"
                placement={hintPosition}
                text={labelHint}
              />
            )}
          </Label>
        )}
        {
          <div
            data-testid={dataTestId}
            className={classNames(classes.select, customClassname)}
          >
            <AsyncSelect
              key={this.chaveId}
              onBlur={this.props.onBlur}
              isDisabled={disabled}
              isClearable={clearable}
              cacheOptions={true}
              defaultOptions={false}
              getOptionLabel={(option) => option[labelKey]}
              getOptionValue={getOptionValue || ((option) => option[valueKey])}
              formatOptionLabel={
                optionRenderer || valueRenderer
                  ? (option, meta) => {
                      if (meta.context === 'menu' && optionRenderer)
                        return optionRenderer(option);
                      if (meta.context === 'value' && valueRenderer)
                        return valueRenderer(option);
                      return option[labelKey];
                    }
                  : undefined
              }
              onChange={this.handleChange}
              isMulti={multi}
              placeholder={placeholder ? placeholder : ''}
              value={model.value}
              loadOptions={this.getOptions}
              filterOption={createFilter({ ignoreAccents: false })}
              noOptionsMessage={({ inputValue }) =>
                inputValue
                  ? intl.formatMessage({ id: 'label.nenhumRegistroEncontrado' })
                  : intl.formatMessage({ id: 'label.digiteParaPesquisar' })
              }
              menuPortalTarget={document.body}
              styles={{
                container: (base) => ({
                  ...base,
                  width: '100%',
                  minWidth: 0,
                  maxWidth: '100%',
                }),
                menuPortal: (base) => ({ ...base, zIndex: 12000 }),
                control: (base) => ({
                  ...base,
                  ...controlStyle,
                  minWidth: 0,
                  maxWidth: '100%',
                  height: 'auto',
                  borderColor: model.errors ? '#f05050' : '#dde6e9',
                  ...(isCompactMulti &&
                    (this.props.valueComponent
                      ? { minHeight: 38 }
                      : { height: 38, minHeight: 38 })),
                }),
                valueContainer: (base) => ({
                  ...base,
                  minWidth: 0,
                  maxWidth: '100%',
                }),
                ...(this.props.valueComponent && {
                  singleValue: (base) => ({
                    ...base,
                    display: 'flex',
                    alignItems: 'center',
                  }),
                }),
                ...(isCompactMulti && compactMultiStyles),
              }}
              components={{
                MultiValue:
                  isCompactMulti && !this.props.valueComponent
                    ? components.MultiValue
                    : this.CustomMultiValue,
                SingleValue: this.CustomSingleValue,
                DropdownIndicator: this.CustomIndicator,
                ...(isCompactMulti && {
                  ValueContainer: CompactMultiValueContainer,
                }),
              }}
              {...other}
            ></AsyncSelect>
          </div>
        }
        {model.erros && <FormFeedback>{model.erros}</FormFeedback>}
      </FormGroup>
    );
  }
}

function mapStateToProps(state) {
  return {
    resources: state.user.termos,
    viewType: state.viewType,
  };
}
export default injectIntl(connect(mapStateToProps)(SelectAsync));
